export default __webpack_public_path__ + "static/media/XRP.32288853.svg";